import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import fileDownload from "js-file-download";

//components
import LoanDetails from "./LoanDetails";

//actions
import {
  getAmortizationTableAction,
  getEmiAmountSplitupAction,
} from "./LoanDetailsAction";

import {
  getLoanApplicationByIdAction,
  getClientInfoByIdAction,
  getReceiptAction,
} from "../LoanApplicationList/LoanApplicationListAction";
import { setSearchFilterAction } from "../redux/Action";
import { saveLoanID } from "../AuditTrail/AuditTrailAction";

//constants
import {
  API_RESPONSE_STATUS_CODES,
  DASHBOARD_FILTER,
  SEARCH_FILTER_PAGES,
} from "../Utils/Constants";
import { RECEIPT_TYPES } from "../LoanApplicationList/Constants";

import { APPLICATION_CONFIGURATIONS } from "../Utils/ApplicationConfigurations";

import UserNotification from "../CustomUIComponents/UserNotification/UserNotification";
import LoadingModal from "../CustomUIComponents/LoadingModal/LoadingModal";

class LoanDetailsContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      amortizationData: [],
      summaryData: [],
      toShowToast: false,
      message: "",
      level: "",
      title: "",
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    this.onLoad();
  }

  componentWillUnmount() {
    if (
      this.props.searchPage === SEARCH_FILTER_PAGES.DASHBOARD &&
      this.props.history.location.pathname !==
        APPLICATION_CONFIGURATIONS.path.dashboard
    ) {
      this.props.setSearchFilterAction(SEARCH_FILTER_PAGES.DASHBOARD, {
        ...DASHBOARD_FILTER,
      });
    }
  }

  getLoanApplication = () => {
    this.props.getLoanApplicationByIdAction(
      this.props.loanApplicationListReducer.applicationId,
      (responseStatus, responseData) => {
        if (responseStatus === API_RESPONSE_STATUS_CODES.SUCCESS) {
          this.setState({
            loanDetails: responseData,
          });
        }
      }
    );
  };

  onLoad = () => {
    this.getClientInfo();
    this.getLoanApplication();
  };

  getClientInfo = () => {
    this.setState({ showLoadingModal: true });
    this.props.getClientInfoByIdAction(
      this.props.loanApplicationListReducer.loanApplicationDetails.basicInfo
        .clientUniqueId,
      (responseCode, responseData) => {
        let error = "";
        if (responseCode !== API_RESPONSE_STATUS_CODES.SUCCESS) {
        }
        this.setState({
          showLoadingModal: false,
          error: error,
        });
      }
    );
  };

  getAmortizationTable = (req) => {
    this.setState({ showLoadingModal: true });
    //call search API
    let request = {
      applicationId: this.props.loanApplicationListReducer.applicationId,
      limit: req.limit,
      offset: req.offset - 1,
    };
    getAmortizationTableAction(request, (responseData) => {
      if (responseData.status === API_RESPONSE_STATUS_CODES.SUCCESS) {
        this.setState({
          amortizationData: responseData.data.amortizations,
          summaryData: [responseData.data.summary],
          numberOfPages: responseData.data.numberOfPages,
          showLoadingModal: false,
        });
      }
    });
  };

  getEmiAmountSplitup = (request) => {
    this.setState({ showLoadingModal: true });
    getEmiAmountSplitupAction(request, (responseData) => {
      if (responseData.status === API_RESPONSE_STATUS_CODES.SUCCESS) {
        this.setState({
          amountSplitUpData: responseData.data.ad,
          showLoadingModal: false,
        });
      }
    });
  };

  downloadReceipt = (data, receiptType) => {
    let filename;
    switch (receiptType) {
      case RECEIPT_TYPES.submit:
        filename =
          "Acuse_de_recibo-" +
          this.props.loanApplicationListReducer.applicationId +
          ".pdf";
        break;
      case RECEIPT_TYPES.disburse:
        filename =
          "Recibo de desembolso-" +
          this.props.loanApplicationListReducer.applicationId +
          ".pdf";
        break;
      case RECEIPT_TYPES.collection:
        filename = "Recibo_de_pago_para.pdf";
        break;
      case RECEIPT_TYPES.paymentReceipt:
        filename = "Recibo_de_pago_para.pdf";
        break;
      default:
        filename = "default.pdf";
        break;
    }
    fileDownload(data, filename);
  };

  downloadDisbursementReceipt = () => {
    this.props.getReceiptAction(
      this.props.loanApplicationListReducer.applicationId,
      RECEIPT_TYPES.disburse,
      (responseData) => {
        if (responseData.data !== null) {
          this.downloadReceipt(responseData.data, RECEIPT_TYPES.disburse);
        }
      }
    );
  };

  downloadPaymentReceipt = (receiptId, type) => {
    this.props.getReceiptAction(receiptId, type, (responseData) => {
      if (responseData !== null) {
        this.downloadReceipt(responseData, type);
      }
    });
  };

  redirectToAdminAudit = () => {
    this.props.saveLoanID({
      auditType: "LOAN_AUDIT",
      performedOn: this.props.loanApplicationListReducer.applicationId,
    });
    this.props.history.push(APPLICATION_CONFIGURATIONS.path.auditTrail);
  };

  render() {
    return (
      <>
        <LoadingModal showLoadingModal={this.state.showLoadingModal} />{" "}
        {this.state.toShowToast && (
          <UserNotification
            userNotificationObj={{
              message: this.state.message,
              level: this.state.level,
              title: this.state.level === "success" ? "Success !" : "Errorr !",
            }}
          />
        )}
        <LoanDetails
          showLoadingModal={this.state.showLoadingModal}
          loanApplicationListReducer={this.props.loanApplicationListReducer}
          amortizationData={this.state.amortizationData}
          summaryData={this.state.summaryData}
          getAmortizationTable={this.getAmortizationTable}
          numberOfPages={this.state.numberOfPages}
          downloadDisbursementReceipt={this.downloadDisbursementReceipt}
          downloadPaymentReceipt={this.downloadPaymentReceipt}
          getEmiAmountSplitup={this.getEmiAmountSplitup}
          amountSplitUpData={this.state.amountSplitUpData}
          loginReducer={this.props.loginReducer}
          redirectToAdminAudit={this.redirectToAdminAudit}
        />
      </>
    );
  }
}
function mapStateToProps(state) {
  return {
    loanApplicationListReducer: state.loanApplicationListReducer,
    loginReducer: state.loginReducer,
    searchPage: state.searchFilterReducer.searchPage,
  };
}

function matchDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      getAmortizationTableAction: getAmortizationTableAction,
      getClientInfoByIdAction: getClientInfoByIdAction,
      getReceiptAction: getReceiptAction,
      getEmiAmountSplitupAction: getEmiAmountSplitupAction,
      getLoanApplicationByIdAction: getLoanApplicationByIdAction,
      setSearchFilterAction: setSearchFilterAction,
      saveLoanID: saveLoanID,
    },
    dispatch
  );
}

export default connect(mapStateToProps, matchDispatchToProps, null, {
  withRef: true,
})(LoanDetailsContainer);
